import type { Perms } from "@/hooks/use-permissions";

export const permissionKey = (permissions: Perms) => JSON.stringify(permissions);

export const getUniquePermissions = (permissions: Perms[]) =>
  Array.from(
    new Map(permissions.map((permission) => [permissionKey(permission), permission])).values(),
  );

export const MERCHANT_SHELL_PERMISSION_CHECKS: Perms[] = getUniquePermissions([
  { metrics: ["read"] },
  { roadmap: ["read"] },
  { experiments: ["read"] },
  { sensitiveData: ["read"] },
  { aiDiscovery: ["read"] },
  { sensitiveData: ["read"], billing: ["read"] },
  { aiChat: ["read"] },
  { messaging: ["read"] },
  { messaging: ["write"] },
]);

export type PrefetchedPermissions = Record<string, boolean>;
